<div fxLayout="column">
  <mat-card [style.background-color]="uiData.individual.color">
    <mat-card-title>
      Add Affiliation
    </mat-card-title>
  </mat-card>

  <div class="scroll-container">
    <mat-form-field style="width: 100%;">
      <mat-label>Search ATP or Firm</mat-label>
      <input matInput [(ngModel)]="selectedOption" [matAutocomplete]="auto" (input)="updateSearch($event)">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayOption" (optionSelected)="selectedOption = $event.option.value">
        <mat-option *ngFor="let option of filteredOptions" [value]="option">
          {{ option.type + ': ' + option.name }}
        </mat-option>
      </mat-autocomplete>
      <mat-hint>Private and public ATP/Firm options are shown.</mat-hint>
    </mat-form-field>

    <div *ngIf="loading">Loading affiliation options...</div>
    <div *ngIf="!loading && filteredOptions.length === 0">No matching affiliations found.</div>
  </div>

  <mat-card [style.background-color]="uiData.individual.color" fxLayout="row wrap" fxLayoutGap="8px">
    <button mat-raised-button color="primary" [disabled]="!isOptionSelected()" (click)="onSubmit()">Add</button>
    <button mat-raised-button (click)="onCancel()">Cancel</button>
  </mat-card>
</div>
